module.exports = __webpack_public_path__ + "img/9788974839109.40ab9c10.jpg";